import { useLang } from "@/i18n/LanguageContext";
import { motion } from "framer-motion";
import { ASSETS } from "@/lib/assets";

export default function WhatsIncluded({ onUpload }) {
  const { t } = useLang();
  const w = t.whatsIncluded;

  return (
    <section id="included" data-testid="whats-included" className="scroll-mt-28 bg-zinc-50 py-24 md:py-32">
      <div className="container-x">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <span className="overline">{w.overline}</span>
            <h2 className="mt-4 text-4xl text-zinc-900 md:text-[44px] md:leading-[1.06]">{w.title}</h2>
            <p className="mt-4 text-base text-zinc-600">{w.subtitle}</p>
            <button type="button" onClick={onUpload} className="btn-primary mt-8" data-testid="whats-included-cta">
              {w.cta}
            </button>
          </div>

          <div className="space-y-4 lg:col-span-4">
            {w.features.map((feature, i) => (
              <motion.div
                key={feature.title}
                initial={{ opacity: 0, x: -12 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ delay: i * 0.06 }}
                className="rounded-2xl border border-zinc-200 bg-white p-5"
                data-testid={`included-feature-${i}`}
              >
                <h3 className="text-base font-semibold text-zinc-900">{feature.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-zinc-600">{feature.description}</p>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.6 }}
            className="lg:col-span-3"
          >
            <div className="overflow-hidden rounded-[28px] border border-zinc-200 shadow-[0_24px_60px_-36px_rgba(81,75,186,0.35)]">
              <img
                src={ASSETS.lifestyle}
                alt=""
                loading="lazy"
                className="aspect-[3/4] w-full object-cover"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
